/* assets/rk-print-4x6.js
   RecipeKit landscape 4x6 (6"×4") print cards + 8.5x11 button
   - Adds “Print recipe cards: 4×6 8.5×11” bar
   - 4×6 prints custom cards (2 per Letter page stacked)
   - 8.5×11 triggers RecipeKit default print
   - Includes Notes/Tips columns
   - Adds footer: © Just Like Oma • quick-german-recipes.com + card numbering
   - Guards against duplicate execution / duplicate handlers (singleton + per-root dataset flag)
*/
(function () {
  "use strict";

  if (window.__JLO_RK_PRINT_4X6_LOADED__) return;
  window.__JLO_RK_PRINT_4X6_LOADED__ = true;

  const SELECTORS = {
    recipeRoot: ".rk_container, .shopify-app-block .rk_container",
    title: "h2.rk_heading",

    ingredientsBox: ".rk_ingredients",
    directionsBox: ".rk_directions",

    groupHeading: "h4.rk_group_heading",
    ingredientsGroupList: "ul.recipe-ingredients-group",

    column: ".rk_column",
    columnHeading: "h2.rk_column_heading",

    anyPrintEl: ".rk_print, [onclick*='rk_print_function']"
  };

  const FOOTER_SITE_TEXT = "© Just Like Oma • quick-german-recipes.com";

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
  function txt(el) { return (el && el.textContent ? el.textContent.trim() : ""); }

  function getRecipeRoot() {
    return qs(SELECTORS.recipeRoot);
  }

  function ensurePrintbar() {
    const root = getRecipeRoot();
    if (!root) return;

    if (root.dataset.rkPrintbarInit === "1") return;
    root.dataset.rkPrintbarInit = "1";

    const originalPrint = root.querySelector(SELECTORS.anyPrintEl);
    if (originalPrint) originalPrint.classList.add("rk-print-original");

    const bar = document.createElement("div");
    bar.className = "rk-printbar";

    const label = document.createElement("div");
    label.className = "rk-printbar-label";
    label.textContent = "Print recipe cards:";

    const btn4x6 = document.createElement("button");
    btn4x6.type = "button";
    btn4x6.className = "rk-printbtn";
    btn4x6.textContent = "4×6";
    btn4x6.addEventListener("click", onPrint4x6, { passive: true });

    const btn85 = document.createElement("button");
    btn85.type = "button";
    btn85.className = "rk-printbtn";
    btn85.textContent = "8.5×11";
    btn85.addEventListener("click", () => onPrint85x11(originalPrint), { passive: true });

    bar.appendChild(label);
    bar.appendChild(btn4x6);
    bar.appendChild(btn85);

    root.appendChild(bar);
  }

  function onPrint85x11(originalPrintEl) {
    if (typeof window.rk_print_function === "function") {
      window.rk_print_function();
      return;
    }
    if (originalPrintEl && typeof originalPrintEl.click === "function") {
      originalPrintEl.click();
      return;
    }
    alert("RecipeKit print handler not found. We may need to adjust the print selector.");
  }

  function extractIngredientGroups(root) {
    const box = qs(SELECTORS.ingredientsBox, root);
    if (!box) return [];

    const heads = qsa(SELECTORS.groupHeading, box);
    const groups = [];

    if (heads.length) {
      heads.forEach(h => {
        const label = txt(h);
        const list = h.nextElementSibling && h.nextElementSibling.matches(SELECTORS.ingredientsGroupList)
          ? h.nextElementSibling
          : null;
        const items = list ? qsa("li", list).map(li => txt(li)).filter(Boolean) : [];
        groups.push({ label, items });
      });
      return groups;
    }

    const list = qs(SELECTORS.ingredientsGroupList, box);
    const items = list ? qsa("li", list).map(li => txt(li)).filter(Boolean) : [];
    return [{ label: "Ingredients", items }];
  }

  function extractDirectionGroups(root) {
    const box = qs(SELECTORS.directionsBox, root);
    if (!box) return [];

    const heads = qsa(SELECTORS.groupHeading, box);
    const groups = [];

    if (heads.length) {
      heads.forEach(h => {
        const label = txt(h);

        let sib = h.nextElementSibling;
        let list = null;
        while (sib) {
          if (sib.matches("ol") && sib.querySelector("li")) { list = sib; break; }
          if (sib.matches(SELECTORS.groupHeading)) break;
          sib = sib.nextElementSibling;
        }

        const items = list ? qsa("li", list).map(li => txt(li)).filter(Boolean) : [];
        groups.push({ label, items });
      });
      return groups;
    }

    const lists = qsa("ol", box).filter(ol => ol.querySelector("li"));
    const items = lists.length ? qsa("li", lists[0]).map(li => txt(li)).filter(Boolean) : [];
    return [{ label: "Directions", items }];
  }

  function extractNotes(root) {
    const cols = qsa(SELECTORS.column, root);
    const blocks = [];

    cols.forEach(col => {
      const h = qs(SELECTORS.columnHeading, col);
      if (!h) return;

      const heading = txt(h);
      if (!/(recipe note|tips|tip|hints|hint|notes|note)/i.test(heading)) return;

      const clone = col.cloneNode(true);
      const ch = qs(SELECTORS.columnHeading, clone);
      if (ch) ch.remove();

      const items = qsa("li", clone).map(li => txt(li)).filter(Boolean);
      if (items.length) {
        blocks.push({ heading, items, isList: true });
        return;
      }

      const paras = qsa("p", clone).map(p => txt(p)).filter(Boolean);
      if (paras.length) {
        blocks.push({ heading, items: paras, isList: paras.length > 1 });
        return;
      }

      const lines = clone.textContent
        .split("\n")
        .map(s => s.trim())
        .filter(Boolean);

      if (lines.length) {
        blocks.push({ heading, items: lines, isList: lines.length > 1 });
      }
    });

    return blocks;
  }

  function addFooterToCard(card, siteText, countText) {
    if (card.querySelector(".rk-4x6-footer")) return;

    const footer = document.createElement("div");
    footer.className = "rk-4x6-footer";

    const left = document.createElement("div");
    left.className = "rk-4x6-site";
    left.textContent = siteText;

    const right = document.createElement("div");
    right.className = "rk-4x6-count";
    right.textContent = countText;

    footer.appendChild(left);
    footer.appendChild(right);
    card.appendChild(footer);
  }

  function stampCardsWithFooters(cards, siteText) {
    const printable = cards.filter(c => !c.getAttribute("data-rk-blank"));
    const total = printable.length;

    printable.forEach((card, i) => {
      addFooterToCard(card, siteText, `${i + 1}/${total}`);
    });
  }

  function createCard(title, sectionLabel, opts = {}) {
    const card = document.createElement("div");
    card.className = "rk-4x6-card";

    if (opts.isBlank) {
      card.setAttribute("data-rk-blank", "1");
      return card;
    }

    const t = document.createElement("div");
    t.className = "rk-4x6-title";
    t.textContent = title;

    const sec = document.createElement("div");
    sec.className = "rk-4x6-section";
    sec.textContent = sectionLabel;

    card.appendChild(t);
    card.appendChild(sec);
    return card;
  }

  function buildMeasureCard() {
    const m = document.createElement("div");
    m.style.position = "fixed";
    m.style.left = "-9999px";
    m.style.top = "0";
    m.style.width = "6in";
    m.style.height = "4in";
    m.style.boxSizing = "border-box";
    m.style.border = "1px solid transparent";
    m.style.padding = "0.16in";
    m.style.paddingBottom = "0.34in";
    m.style.overflow = "hidden";
    m.style.fontFamily = "serif";
    m.style.lineHeight = "1.15";
    document.body.appendChild(m);
    return m;
  }

  function buildCardsFromGroups({ title, sectionBase, listTag, groups }) {
    const cards = [];
    const measure = buildMeasureCard();

    groups.forEach(g => {
      const groupLabel = g.label || sectionBase;
      const showSubhead = groupLabel.trim().toLowerCase() !== sectionBase.trim().toLowerCase();
      const items = g.items || [];
      if (!items.length) return;

      let idx = 0;
      let part = 1;

      while (idx < items.length) {
        const label = part === 1 ? sectionBase : `${sectionBase} (cont.)`;
        const startNumber = idx + 1;

        measure.innerHTML = "";
        const mTitle = document.createElement("div");
        mTitle.style.fontSize = "12pt";
        mTitle.style.fontWeight = "700";
        mTitle.style.margin = "0 0 6px 0";
        mTitle.textContent = title;

        const mSec = document.createElement("div");
        mSec.style.fontSize = "9pt";
        mSec.style.fontWeight = "700";
        mSec.style.margin = "6px 0 4px 0";
        mSec.style.textTransform = "uppercase";
        mSec.style.letterSpacing = "0.03em";
        mSec.textContent = label;

        measure.appendChild(mTitle);
        measure.appendChild(mSec);

        if (showSubhead) {
          const mSub = document.createElement("div");
          mSub.style.fontSize = "9pt";
          mSub.style.fontWeight = "700";
          mSub.style.margin = "6px 0 4px 0";
          mSub.textContent = groupLabel;
          measure.appendChild(mSub);
        }

        const mList = document.createElement(listTag);
        mList.style.margin = "0";
        mList.style.paddingLeft = "16px";
        mList.style.fontSize = "9pt";

        if (listTag.toLowerCase() === "ol") {
          mList.start = startNumber;
        }

        measure.appendChild(mList);

        while (idx < items.length) {
          const li = document.createElement("li");
          li.textContent = items[idx];
          li.style.marginBottom = "3px";
          mList.appendChild(li);

          if (measure.scrollHeight > measure.clientHeight) {
            mList.removeChild(li);
            break;
          }
          idx++;
        }

        const card = createCard(title, label);

        if (showSubhead) {
          const sub = document.createElement("div");
          sub.className = "rk-4x6-subhead";
          sub.textContent = groupLabel;
          card.appendChild(sub);
        }

        const list = document.createElement(listTag);

        if (listTag.toLowerCase() === "ol") {
          list.start = startNumber;
        }

        card.appendChild(list);

        Array.from(mList.querySelectorAll("li")).forEach(mli => {
          const li = document.createElement("li");
          li.textContent = mli.textContent || "";
          list.appendChild(li);
        });

        if (!list.children.length && idx < items.length) {
          const li = document.createElement("li");
          li.textContent = items[idx];
          list.appendChild(li);
          idx++;
        }

        cards.push(card);
        part++;
      }
    });

    measure.remove();
    return cards;
  }

  function buildNotesCards(title, noteBlocks) {
    if (!noteBlocks.length) return [];

    const tokens = [];
    noteBlocks.forEach(b => {
      b.items.forEach(item => {
        tokens.push({ type: b.isList ? "li" : "p", text: item });
      });
    });

    const cards = [];
    const measure = buildMeasureCard();
    let idx = 0;

    while (idx < tokens.length) {
      measure.innerHTML = "";

      const mTitle = document.createElement("div");
      mTitle.style.fontSize = "11pt";
      mTitle.style.fontWeight = "700";
      mTitle.style.margin = "0 0 5px 0";
      mTitle.textContent = title;

      const mSec = document.createElement("div");
      mSec.style.fontSize = "8.5pt";
      mSec.style.fontWeight = "700";
      mSec.style.margin = "5px 0 3px 0";
      mSec.style.textTransform = "uppercase";
      mSec.style.letterSpacing = "0.03em";
      mSec.textContent = "Notes / Tips";

      const mBody = document.createElement("div");
      mBody.style.fontSize = "8.5pt";
      mBody.style.lineHeight = "1.1";

      measure.appendChild(mTitle);
      measure.appendChild(mSec);
      measure.appendChild(mBody);

      let mCurrentList = null;
      let lastType = null;

      while (idx < tokens.length) {
        const tok = tokens[idx];
        let node;

        if (tok.type === "li") {
          if (lastType !== "li" || !mCurrentList) {
            mCurrentList = document.createElement("ul");
            mCurrentList.style.margin = "3px 0 0 0";
            mCurrentList.style.paddingLeft = "14px";
            mCurrentList.style.listStylePosition = "outside";
            mBody.appendChild(mCurrentList);
          }

          node = document.createElement("li");
          node.style.marginBottom = "2px";
          node.style.fontSize = "8.5pt";
          node.style.lineHeight = "1.1";
          node.textContent = tok.text;
          mCurrentList.appendChild(node);

          if (measure.scrollHeight > measure.clientHeight) {
            mCurrentList.removeChild(node);
            if (!mCurrentList.children.length) mCurrentList.remove();
            break;
          }

          lastType = "li";
          idx++;
          continue;
        }

        mCurrentList = null;
        lastType = "p";

        node = document.createElement("p");
        node.style.fontSize = "8.5pt";
        node.style.lineHeight = "1.1";
        node.style.margin = "3px 0 0 0";
        node.textContent = tok.text;
        mBody.appendChild(node);

        if (measure.scrollHeight > measure.clientHeight) {
          mBody.removeChild(node);
          break;
        }

        idx++;
      }

      const card = createCard(title, "Notes / Tips");
      const body = document.createElement("div");
      body.className = "rk-4x6-note";
      card.appendChild(body);

      Array.from(mBody.childNodes).forEach(n => body.appendChild(n.cloneNode(true)));
      cards.push(card);
    }

    measure.remove();
    return cards;
  }

  function buildPrintSheet(cards) {
    const old = document.getElementById("rk-print-4x6-sheet");
    if (old) old.remove();

    const sheet = document.createElement("div");
    sheet.id = "rk-print-4x6-sheet";

    if (cards.length % 2 === 1) {
      cards.push(createCard("", "", { isBlank: true }));
    }

    for (let i = 0; i < cards.length; i += 2) {
      const page = document.createElement("div");
      page.className = "rk-4x6-page";
      page.appendChild(cards[i]);
      page.appendChild(cards[i + 1]);
      sheet.appendChild(page);
    }

    document.body.appendChild(sheet);
  }

  function onPrint4x6() {
    const root = getRecipeRoot();
    if (!root) return;

    if (window.__JLO_RK_PRINT_4X6_BUSY__) return;
    window.__JLO_RK_PRINT_4X6_BUSY__ = true;

    try {
      const title = txt(qs(SELECTORS.title, root)) || "Recipe";

      const ingGroups = extractIngredientGroups(root);
      const dirGroups = extractDirectionGroups(root);
      const noteBlocks = extractNotes(root);

      const ingCards = buildCardsFromGroups({ title, sectionBase: "Ingredients", listTag: "ul", groups: ingGroups });
      const dirCards = buildCardsFromGroups({ title, sectionBase: "Directions", listTag: "ol", groups: dirGroups });
      const noteCards = buildNotesCards(title, noteBlocks);

      const all = [...ingCards, ...dirCards, ...noteCards];

      stampCardsWithFooters(all, FOOTER_SITE_TEXT);
      buildPrintSheet(all);

      document.documentElement.classList.add("rk-print-4x6");

      let cleaned = false;

      const cleanup = () => {
        if (cleaned) return;
        cleaned = true;

        window.removeEventListener("afterprint", cleanup);

        setTimeout(() => {
          document.documentElement.classList.remove("rk-print-4x6");
          const el = document.getElementById("rk-print-4x6-sheet");
          if (el) el.remove();
          window.__JLO_RK_PRINT_4X6_BUSY__ = false;
        }, 250);
      };

      window.addEventListener("afterprint", cleanup);

      window.print();

      setTimeout(() => {
        cleanup();
      }, 2000);
    } catch (e) {
      window.__JLO_RK_PRINT_4X6_BUSY__ = false;
      console.error("4x6 print error:", e);
      alert("4×6 printing hit an error. Check the console for details.");
    }
  }

  function init() {
    ensurePrintbar();

    let tries = 0;
    const t = setInterval(() => {
      ensurePrintbar();
      tries++;
      if (tries >= 30) clearInterval(t);
    }, 400);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();